import {LoadingButton} from '@mui/lab'
import {Button, Divider} from '@mui/material'
import {yMarker} from 'assets/imageDeclear'
import {fabric} from 'fabric'
import {envImagePath} from 'GLOBAL/envVariables'
import {useEffect, useRef, useState} from 'react'
import {Map, MapMarker, MapTypeControl} from 'react-kakao-maps-sdk'
import {useSelector} from 'react-redux'
import {requestAsComplete} from 'utils/apiCalling/api'
import {globalSerialNumberFormatWithHyphens, meterReadEnum} from 'utils/const/globalConst'
import {playConfirm} from 'utils/CustomAlert/Alert'
const AsInstallComplete = (props: any) => {
  const {asSubmit, step, clear, close, countCall, set, getPosition} = props
  const [loading, setLoading] = useState<boolean>(false)
  const [gpsLoading, setGpsLoading] = useState<boolean>(false)
  const [gpsError, setGpsError] = useState<string | null>(null)
  const [retryCount, setRetryCount] = useState<number>(0)
  const position = useSelector((state: any) => state?.currentPosition.position)
  const canvasRef = useRef(null)
  const [canvas, setCanvas] = useState<any>(null)
  const mapRef = useRef<any>(null)
  const gpsAvailable =
    window.location.protocol === 'https:' || window.location.hostname === 'localhost'
  const gpsReady = position?.latitude !== 0 && position?.longitude !== 0
  const MAX_RETRIES = 2

  const tryGetPosition = (retry: number = 0) => {
    setGpsLoading(true)
    setGpsError(null)
    setRetryCount(retry)
    getPosition(
      () => {
        setGpsLoading(false)
        setRetryCount(0)
      },
      (err: string) => {
        if (retry < MAX_RETRIES) {
          setTimeout(() => tryGetPosition(retry + 1), 1500)
        } else {
          setGpsError(err)
          setGpsLoading(false)
          setRetryCount(0)
        }
      }
    )
  }

  useEffect(() => {
    if (step === 3) {
      if (gpsAvailable) tryGetPosition()
      setTimeout(() => {
        const canvasInstance = new fabric.Canvas('installer-imageInfo', {
          width: 320,
          height: 144,
        })
        setCanvas(canvasInstance)

        return () => {
          canvasInstance.dispose()
        }
      }, 100)
    }
  }, [step])

  useEffect(() => {
    set({...asSubmit, latitude: position.latitude, longitude: position.longitude})
  }, [position])

  useEffect(() => {
    if (!canvas) return

    if (asSubmit?.filePath) {
      // const imageUrl = envImagePath+ device?.imageUrl
      const imageUrl = envImagePath + asSubmit?.filePath
      fabric.Image.fromURL(imageUrl, (img: any) => {
        const imgWidth = img.width || 320
        const imgHeight = img.height || 144
        const canvasWidth = canvas.width
        const canvasHeight = canvas.height
        let newWidth = imgWidth
        let newHeight = imgHeight
        // 이미지가 캔버스보다 크면 크기조정
        if (imgWidth > canvasWidth || imgHeight > canvasHeight) {
          const widthRatio = canvasWidth / imgWidth
          const heightRatio = canvasHeight / imgHeight

          newWidth = imgWidth * widthRatio
          newHeight = imgHeight * heightRatio
        }
        canvas.setDimensions({width: newWidth, height: newHeight})

        img.set({
          left: newWidth / 2,
          top: newHeight / 2,
          originX: 'center',
          originY: 'center',
          scaleX: newWidth / imgWidth,
          scaleY: newHeight / imgHeight,
          selectable: false,
          angle: asSubmit?.rotate,
        })

        canvas.clear()
        canvas.add(img)

        const horizontalRect = new fabric.Rect({
          left: asSubmit?.xstart * (canvasWidth / imgWidth),
          top: asSubmit?.ystart * (canvasHeight / imgHeight),
          width: (asSubmit?.xend - asSubmit?.xstart) * (canvasWidth / imgWidth),
          height: (asSubmit?.yend - asSubmit?.ystart) * (canvasHeight / imgHeight),
          scaleX: 1,
          scaleY: 1,
          fill: 'transparent',
          stroke: 'red',
          strokeWidth: 2,
          selectable: false,
          rotatable: false,
          cornerColor: 'white',
          cornerSize: 15,
        })
        canvas.add(horizontalRect)
        canvas.renderAll()
      })
    }
  }, [canvas, asSubmit?.xend])
  const typeName = (name: string) => {
    switch (name) {
      case 'analog':
        return meterReadEnum.ANALOG
      case 'digital':
        return meterReadEnum.DIGITAL
      case 'gas':
        return meterReadEnum.GAS
      case 'PRV':
        return meterReadEnum.PRV
    }
  }
  const requestTargetName = (idx: any) => {
    switch (idx) {
      case 1:
        return 'efosChange'
      case 2:
        return 'deviceChange'
      case 3:
        return 'deviceChange'
      case 4:
        return 'efosChange'
      case 5:
        return 'normalChange'
      case 6:
        return 'normalChange'
      case 7:
        return 'normalChange'
      case 8:
        return 'normalChange'
      case 9:
        return 'normalChange'
      case 10:
        return 'normalChange'
      default:
        return ''
    }
  }
  const requestAsCompleteCall = async () => {
    const confirmMessage = `수용가명: ${asSubmit?.customerName}\n수용가번호: ${
      asSubmit?.customerNumber
    }\n단말기 S/N: ${globalSerialNumberFormatWithHyphens(asSubmit?.serialNumber)}${
      !gpsReady ? '\n\n⚠ 위경도가 0,0입니다. GPS 재수신을 권장합니다.' : ''
    }\n\n해당 단말기를 A/S 완료 처리하시겠습니까?`
    const confirmed = await playConfirm(
      'A/S 확인',
      confirmMessage,
      !gpsReady ? 'warning' : 'info',
      'A/S 완료'
    )
    if (!confirmed) return
    if (requestTargetName(asSubmit.resultIdx) === '') return

    setLoading(true)
    return requestAsComplete(requestTargetName(asSubmit.resultIdx), asSubmit, {
      success: (res: any) => {
        if (res.resultCode === 0) {
          close()
          clear()
          countCall()
        } else {
          setLoading(false)
        }
      },
      fail: (err: any) => {
        console.log(err)
        setLoading(false)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  return (
    <article className={'row gap-4 px-3 justify-content-center pb-3'}>
      <div className={'w-100 d-flex flex-column gap-2'}>
        {[
          {label: '고객 번호', value: asSubmit?.customerNumber},
          {label: '고객 이름', value: asSubmit?.customerName},
          {label: '단말기 S/N', value: globalSerialNumberFormatWithHyphens(asSubmit?.serialNumber)},
          {label: '단말기 IMEI', value: asSubmit?.imei},
          ...(asSubmit?.deviceType === 'analog' &&
          !(asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10)
            ? [
                {label: '검침기 자리수', value: asSubmit?.digit},
                {label: '계량기 종류', value: typeName(asSubmit?.recognizedType)},
              ]
            : []),
        ].map(({label, value}) => (
          <div
            key={label}
            className={'d-flex justify-content-between align-items-center py-2'}
            style={{borderBottom: '1px solid #475569'}}
          >
            <span className={'text-dark fw-semibold text-2xl'}>{label}</span>
            <span className={'fw-bold text-3xl'}>{value}</span>
          </div>
        ))}
      </div>

      {asSubmit?.deviceType === 'analog' &&
        !(asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10) && (
          <canvas id='installer-imageInfo' ref={canvasRef} className={'border border-gray-400'} />
        )}

      <div className={'w-100'}>
        {gpsLoading ? (
          <div className={'d-flex align-items-center gap-2 text-primary text-3xl fw-bold'}>
            <span className='spinner-border' />
            <span>
              GPS 수신 중{retryCount > 0 ? ` (재시도 ${retryCount}/${MAX_RETRIES})` : '...'}
            </span>
          </div>
        ) : gpsReady ? (
          <div className={'d-flex flex-column gap-2'}>
            {[
              {label: '위도', value: asSubmit?.latitude},
              {label: '경도', value: asSubmit?.longitude},
            ].map(({label, value}) => (
              <div
                key={label}
                className={'d-flex justify-content-between align-items-center py-2'}
                style={{borderBottom: '1px solid #475569'}}
              >
                <span className={'text-dark fw-semibold fs-4'}>{label}</span>
                <span className={'fw-bold fs-3'}>{value}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className={'d-flex flex-column gap-2'}>
            <div className={'d-flex align-items-center gap-3'}>
              <span className={'text-danger text-2xl fw-bold'}>GPS 수신 실패</span>
              <Button
                variant={'outlined'}
                color={'error'}
                size={'small'}
                onClick={() => tryGetPosition(0)}
              >
                재시도
              </Button>
            </div>
            {gpsError && <span className={'text-danger text-2xl'}>{gpsError}</span>}
          </div>
        )}
      </div>

      {gpsReady && (
        <Map
          id='map'
          center={{lat: position?.latitude, lng: position?.longitude}}
          onCreate={(map: any) => (mapRef.current = map)}
          isPanto={false}
          style={{width: '100%', height: 'clamp(150px, 35dvh, 250px)'}}
          level={3}
          mapTypeId={kakao?.maps.MapTypeId.ROADMAP}
          className={'mt-2 rounded p-4'}
          draggable={false}
          zoomable={false}
        >
          <MapTypeControl position={kakao?.maps.ControlPosition.TOPRIGHT} />
          <MapMarker
            position={{lat: position?.latitude, lng: position?.longitude}}
            draggable={false}
            image={{src: yMarker, size: {width: 33, height: 45}}}
          />
        </Map>
      )}

      <Divider />
      {loading ? (
        <LoadingButton
          loading
          loadingPosition='center'
          // startIcon={<CompleteI />}
          variant='contained'
        >
          A/S 완료
        </LoadingButton>
      ) : (
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          disabled={
            gpsLoading ||
            (asSubmit?.deviceType === 'analog' &&
              !(asSubmit?.resultIdx >= 5 && asSubmit?.resultIdx <= 10) &&
              (asSubmit?.digit === null || asSubmit?.recognizedType === 'none'))
          }
          onClick={() => requestAsCompleteCall()}
        >
          A/S 완료
        </Button>
      )}
    </article>
  )
}

export default AsInstallComplete
